import { Button, Form, Input, message } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import TableSimple from "../components/TableSimple";
import { getMembers, sendInvite } from "../actions/acc_actions";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import Loading from "../utils/Loading";
import { useState } from "react";

export default function SettingsRoles() {
  const accUrn = useSelector((state) => state.account.urn);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { refetch, isLoading, data } = useQuery({
    queryKey: ["members", accUrn],
    queryFn: () => getMembers(accUrn),
    enabled: !!accUrn,
  });

  const onFinish = (values) => {
    // Check if email exists in users or invites
    const email = values.email.toLowerCase(); // Normalize email for comparison
    const userExists = data?.users?.some(
      (user) => user.email_address?.toLowerCase() === email
    );
    const inviteExists = data?.invites?.some(
      (invite) => invite.email_address?.toLowerCase() === email
    );

    if (userExists) {
      message.error("This email is already associated with an existing user.");
      return;
    }

    if (inviteExists) {
      message.error("An invitation for this email is already pending.");
      return;
    }

    const formData = { roles: ["admin"], accountUrn: accUrn, ...values };
    setLoading(true);
    sendInvite(formData)
      .then(() => {
        message.success("Invitation has been sent successfully.");
        refetch();
        form.resetFields();
      })
      .catch((err) => {
        // console.log(err);
        message.error("Something went wrong!.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (isLoading) return <Loading />;

  return (
    <ContentLayout
      header={
        <>
          <h1>Account Roles</h1>
          <MyBreadcrumb />
        </>
      }
    >
      <h5 style={{ marginBottom: "2rem" }} className="active">
        Users
      </h5>
      <TableSimple data={data} />
      <Form
        form={form}
        className="rewards-form"
        layout="vertical"
        onFinish={onFinish}
      >
        <div className="rewards-form-section roles-form-section">
          <h5 className="active">Invite Team Members</h5>
          <div className="rewards-inputs">
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: "Please enter an email address" },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>
            <div className="form-row">
              <Form.Item
                name="firstName"
                label="First Name"
                rules={[
                  { required: true, message: "Please enter a first name" },
                  {
                    pattern: /^[A-Za-z\s-']+$/,
                    message:
                      "First name can only contain letters, spaces, hyphens, or apostrophes",
                  },
                ]}
              >
                <Input placeholder="Enter first name" />
              </Form.Item>
              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[
                  { required: true, message: "Please enter a last name" },
                  {
                    pattern: /^[A-Za-z\s-']+$/,
                    message:
                      "Last name can only contain letters, spaces, hyphens, or apostrophes",
                  },
                ]}
              >
                <Input placeholder="Enter last name" />
              </Form.Item>
            </div>
          </div>
        </div>
        <Form.Item className="rewards-form-btn">
          <Button loading={loading} type="primary" htmlType="submit">
            {loading ? "Sending" : "Send Invite"}
          </Button>
        </Form.Item>
      </Form>
    </ContentLayout>
  );
}
